import { NgModule } from '@angular/core';
import { StateRefDirective } from './state-ref.directive';
import { CommonModule } from '@angular/common';

@NgModule({
    
    declarations: [
      StateRefDirective
    ],
    imports: [
      CommonModule
    ],
    exports: [
      StateRefDirective
    ],
    providers: [],
})
export class StateRefDirectiveModule {
}
